import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestProductSetsReorder } from "./productSetsReorder.request";

const useBannersReorder = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestProductSetsReorder,
    ...options
  });
};

export default useBannersReorder;
